import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const CouponsView = angular
  .module('acme.view.application.coupons', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.coupons.controllers',
    'acme.view.application.coupons.list',
    'acme.view.application.coupons.create',
    'acme.view.application.coupons.categories',
    'acme.common.directive.dataGrid',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const coupons = {
      name: 'application.coupons',
      url: '/coupons',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'CouponsController',
          templateUrl: 'views/application/views/coupons/coupons.tpl.html',
        },
      },
      data: {
        pageTitle: 'Coupons',
        permissions: ['COUPONS_VIEW'],
      },
    };

    $stateProvider.state(coupons);
  }).name;
